"use strict";

exports.__esModule = true;
exports.AdvancedStripeChartFields = AdvancedStripeChartFields;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _Form = require("../../Form");
var _Timeline = require("../../Timeline");
var _reactDebounceInput = require("react-debounce-input");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var AdvancedStripeChartFieldsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AdvancedStripeChartFields__AdvancedStripeChartFieldsWrapper",
  componentId: "sc-1lt69au-0"
})([".bp6-form-group{margin:0 0 10px 0;}"]);
function AdvancedStripeChartFields(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var elementEditor = props.elementEditor,
    element = props.element,
    path = props.path;
  return /*#__PURE__*/_react["default"].createElement(AdvancedStripeChartFieldsWrapper, {
    "data-testid": "AdvancedStripeChartFields"
  }, /*#__PURE__*/_react["default"].createElement(_Timeline.AdvancedTimelineSelector, props), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("AdvancedTimelineFields.column.label", "Column Label")
    }, /*#__PURE__*/_react["default"].createElement(_reactDebounceInput.DebounceInput, {
      element: _core.InputGroup,
      minLength: 2,
      debounceTimeout: 300,
      value: element.props.columnLabel || "",
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "columnLabel", e.target.value);
      }
    }));
  }), /*#__PURE__*/_react["default"].createElement(_Timeline.AdvancedTimelineLabelSelector, props), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("AdvancedTimeline.LabelColorSelector", "Label Color")
  }, /*#__PURE__*/_react["default"].createElement(_Form.ColorPicker, {
    value: element.props.labelColor,
    onChange: function onChange(color) {
      return elementEditor.setProp(path, "labelColor", color);
    }
  })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_Timeline.AdvancedTimelineToggle, _extends({}, props, {
    propName: "showDivision",
    label: translate("AdvancedTimelineFields.showDivision.label", "Division")
  })), /*#__PURE__*/_react["default"].createElement(_Timeline.AdvancedTimelineToggle, _extends({}, props, {
    propName: "hideXAxis",
    label: translate("AdvancedTimelineFields.hideXAxis.label", "Hide X Axis")
  })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_Timeline.AdvancedTimelineToggle, _extends({}, props, {
    propName: "showComments",
    label: translate("AdvancedTimelineFields.showComments.label", "Comments")
  })), /*#__PURE__*/_react["default"].createElement(_Timeline.AdvancedTimelineToggle, _extends({}, props, {
    propName: "showTickets",
    label: translate("AdvancedTimelineFields.showTickets.label", "Tickets")
  })), /*#__PURE__*/_react["default"].createElement(_Timeline.AdvancedTimelineToggle, _extends({}, props, {
    propName: "showAlerts",
    label: translate("AdvancedTimelineFields.showAlerts.label", "Alerts")
  })), /*#__PURE__*/_react["default"].createElement(_Timeline.AdvancedTimelineTimeContextSelector, props), /*#__PURE__*/_react["default"].createElement(_Timeline.AdvancedTimelineBrushSelector, props));
}